import { NotificationItem } from "./notification-center-response";

const row = ({
    source,
    sourceLink,
    headline,
    text,
    status,
    createdAt,
    timeFormat,
    dateFormat,
    severity,
    closeButtonText,
    closedByName,
    closedByLabel,
    type,
    link,
    linkText,
    notificationUpdateEndpoint,
    notificationUpdateErrorText,
}: NotificationItem): string => {
    return `
    <ux-notification-item
        type="detail"
        ${source ? `source="${source}"` : ""}
        ${sourceLink ? `source-link="${sourceLink}"` : ""}
        ${headline ? `headline="${headline}"` : ""}
        ${text ? `text="${text}"` : ""}
        ${status ? `status="${status}"` : ""}
        ${createdAt ? `created-at="${createdAt}"` : ""}
        ${timeFormat ? `time-format="${timeFormat}"` : ""}
        ${dateFormat ? `date-format="${dateFormat}"` : ""}
        ${severity ? `severity="${severity}"` : ""}
        ${closeButtonText ? `close-button-text="${closeButtonText}"` : ""}
        ${closedByName ? `closed-by-name="${closedByName}"` : ""}
        ${closedByLabel ? `closed-by-label="${closedByLabel}"` : ""}
        ${link ? `link="${link}"` : ""}
        ${linkText ? `link-text="${linkText}"` : ""}
        ${type ? `type="${type}"` : ""}
        ${
            notificationUpdateEndpoint
                ? `notification-update-endpoint="${notificationUpdateEndpoint}"`
                : ""
        }
        ${
            notificationUpdateErrorText
                ? `notification-update-error-text="${notificationUpdateErrorText}"`
                : ""
        }
    ></ux-notification-item>
    `;
};

export default row;
